<template>
  <li
    v-if="showLink"
    data-testid="nav-footer-link"
    class="py-1 border-b border-EXPONDO-grey-10"
    @click="toggleNavigation"
  >
    <CustomLink
      :url="link"
      :type="LINK_TYPE.NoStyle"
    >
      <div class="flex gap-4 items-center">
        <span class="font-normal text-EXPONDO-grey">
          {{ $t(title) }}
        </span>
        <InfoTag
          v-if="tag"
          :text="$t(tag)"
        />
      </div>
    </CustomLink>
  </li>
</template>

<script lang="ts">


import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'NavFooterLink',

  props: {
    url: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    tag: {
      default: '',
      type: String,
    },
  },
  setup(props) {

    const { getAdjustedSlug } = useRouteExtended();
    const { toggleNavigation } = useNavigationState();
    const link = computed(() => getAdjustedSlug(props.url));
    const showLink = computed(() => !!(link.value && props.title));

    return {
      link,
      showLink,
      LINK_TYPE,
      toggleNavigation,
    };
  
  },
});

</script>
